import actions from '@/config/actions';
import mutations from '@/config/mutations';
import ApiService from '@/service/apiService';
import Api from '@/config/api';
import store from '../store';
import Vue from 'vue';

const APPLICANT_ACTIONS = actions.applicant;
const APPLICANT_MUTATIONS = mutations.applicant;

/** Unwrap API envelope { data: message } for list latestContact (contact components pass axios body as-is). */
function normalizeContactForLatestContact(raw) {
  if (!raw || typeof raw !== 'object') return raw;
  const inner = raw.data;
  if (
    inner &&
    typeof inner === 'object' &&
    !Array.isArray(inner) &&
    (Object.prototype.hasOwnProperty.call(inner, '_id') ||
      Object.prototype.hasOwnProperty.call(inner, 'sent_date'))
  ) {
    return inner;
  }
  return raw;
}

export default {
  state: {
    events: [],
    eventModel: [],
    reviewLists: [],
    allReviewListModel: [],
    categories: [],
    applicants: [],
    currentPageApplicants: [],
    applicantStatusToFilter: '未判定',
    showUnconfirmedOnly: true,
    isCheckAll: false,
    reloadApplicants: false,
    jobseekerIds: [],
    previewApplicants: [],
    activeCategory: [],
    favoritesOnly: false,
    scoutOnly: false,
    interviewsOnly: false,
    showSearchModal: false,
    showFilterModal: false,
    showSearchEditModal: false,
    searchParams: {},
    scoutSearchParams: {},
    isJdListSearch: false,
    selectors: {},
    sortBy: '',
    applicantsCount: {},
    pagination: {},
    previewApplicantCounts: {},
    isPreview: false,
    previewListSearchParams: {},
    page: 1,
    mainJobModel: [],
    childJobModel: [],
    englishSkillModel: [],
    finalEducationModel: [],
    reviewListModel: [],
    colorModel: [],
    client_status: [
      '未判定',
      'スカウト対象',
      'スカウト対象外',
      '確認中',
      'スカウト済',
      '返信有',
      '応募有',
      'システム取込み済',
      '中長期対応',
      'その他',
    ],
    showJdSection: true,
    statusColorMap: {
      '未判定': '#DD2A29',
      'スカウト対象': '#006C6B',
      'スカウト対象外': '#AB8271',
      '確認中': '#FFEA00',
      'スカウト済': '#71B566',
      '返信有': '#E08282',
      '応募有': '#14B8A6',
      'システム取込み済': '#787878',
      '中長期対応': '#8F5AA5',
      'その他': '#535252',
    },
    scoutType: [
      '応募案内',
      'カジュアル面談',
      '面接案内',
      '通知のみ'
    ],
    statusModel: [],
    sentStatusModel: [],
    receivedStatusModel: [],
    scoutTypeModel: [],
    profile: null,
    profileLoaded: false,
    profileView: null,
    individualJD: null,
    applicantJD: null,
    jdForContact: null,
    scoutedJD: null,
    userBasedMatching: false,
    listAllJds: false,
    FirstProfileModalOpen: false,
    LastProfileModalOpen: false,
    company_model: [],
    resume_model: null,
    jobSummaryModel: null,
    client_color: {
      白: '#fbfcff',
      赤: '#f4d6d2',
      黄: '#f6f9db',
      青: '#d4e3f7',
      グレー: '#e5e5e5',
    },
    manuallyCheckedJobs: [],
    defaultLoaded: false,
    currentJDListPage: 1,
    loading: false,
    isJdSearch: false,
    hasAssignedApplicants: false,
    scoutedBy: null,
    scoutHope: null, // 'has' | 'none' | null
  },
  mutations: {
    [APPLICANT_MUTATIONS.SET_PROFILE](state, payload) {
      // eslint-disable-next-line
      state.profile = payload;
    },
    [APPLICANT_MUTATIONS.SET_CATEGORIES](state, payload) {
      // eslint-disable-next-line
      state.categories = payload;
    },
    [APPLICANT_MUTATIONS.SET_EVENTS](state, payload) {
      state.events = payload;
    },
    [APPLICANT_MUTATIONS.SET_APPLICANTS](state, payload) {
      // eslint-disable-next-line
      state.applicants = payload;
    },
    [APPLICANT_MUTATIONS.SET_ACTIVE_CATEGORY](state, id) {
      const index = state.activeCategory.indexOf(id);
      if (index > -1) state.activeCategory.splice(index, 1);
      else state.activeCategory.push(id);
    },
    [APPLICANT_MUTATIONS.TOGGLE_FAVORITES](state, flag) {
      // eslint-disable-next-line
      // eslint-disable-next-line
      state.favoritesOnly = flag;
    },
    [APPLICANT_MUTATIONS.TOGGLE_SCOUT](state, flag) {
      // eslint-disable-next-line
      state.scoutOnly = flag;
    },
    [APPLICANT_MUTATIONS.TOGGLE_INTERVIEWS](state, flag) {
      // eslint-disable-next-line
      state.interviewsOnly = flag;
    },
    [APPLICANT_MUTATIONS.TOGGLE_SEARCH_MODAL](state, flag) {
      // eslint-disable-next-line
      state.showSearchModal = flag;
    },
    [APPLICANT_MUTATIONS.TOGGLE_SEARCH_EDIT_MODAL](state, flag) {
      // eslint-disable-next-line
      state.showSearchEditModal = flag;
    },
    [APPLICANT_MUTATIONS.TOGGLE_FILTER_MODAL](state, flag) {
      // eslint-disable-next-line
      state.showFilterModal = flag;
    },
    [APPLICANT_MUTATIONS.CHANGE_SEARCH_PARAMS](state, payload) {
      state.searchParams = payload;
      state.isJdListSearch = false;
      state.isJdSearch = false;  // Reset isJdSearch when search params change
    },
    setScoutSearchParams(state, payload) {
      state.scoutSearchParams = payload;
    },
    [APPLICANT_MUTATIONS.SET_SELECTORS](state, selectors) {
      // eslint-disable-next-but 
      state.selectors = selectors;
    },
    [APPLICANT_MUTATIONS.CHANGE_SORT_COLUMN](state, column) {
      // eslint-disable-next-line
      state.sortBy = column;
    },
    setJdSectionState(state, show) {
      state.showJdSection = show;
      // Persist to sessionStorage
      sessionStorage.setItem('showJdSection', show.toString());
    },
    
    toggleJdSection(state) {
      state.showJdSection = !state.showJdSection;
      // Persist to sessionStorage
      sessionStorage.setItem('showJdSection', state.showJdSection.toString());
    },
    setPagination(state, payload) {
      state.pagination = payload;
    },
    setJdListSearch(state, payload) {
      state.isJdListSearch = payload;
    },
    setLoading(state, payload) {
      state.loading = payload;
    },
    setProfileMemo(state, memo) {
      if (state.profile) {
        Vue.set(state.profile, 'memo', memo);
      }
    },
    setApplicantInterview(state, interview) {
      if (state.profile) {
        Vue.set(state.profile, 'isInterview', interview);
      }
    },
    setApplicantFavorite(state, favorite) {
      if (state.profile) {
        Vue.set(state.profile, 'isFavorite', favorite);
      }
    },
    setApplicantReviewList(state, review_lists) {
      if (state.profile) {
        Vue.set(state.profile, 'review_lists', review_lists);
      }
    },
    setHasAssignedApplicants(state, hasApplicants) {
      state.hasAssignedApplicants = hasApplicants;
    },
    setCurrentPageApplicants(state, payload) {
      state.currentPageApplicants = payload;
    },
    setApplicantStatusToFilter(state, payload) {
      state.applicantStatusToFilter = payload;
    },
    setCheckAll(state, payload) {
      state.isCheckAll = payload;
      state.jobseekerIds = [];

      if (state.isCheckAll) {
        for (let key in state.applicants) {
          state.jobseekerIds.push(state.applicants[key].id);
        }
      }
    },
    setJobseekerIds(state, payload) {
      state.jobseekerIds = payload;
    },
    checkUncheckJobseeker(state, id) {
      const index = state.jobseekerIds.indexOf(id);
      if (index > -1) {
        state.jobseekerIds.splice(index, 1);
      } else {
        state.jobseekerIds.push(id);
      }
    },
    setProfileLoaded(state, payload) {
      state.profileLoaded = payload;
    },
    setApplicantStatus(state, payload) {
      if (state.profile) {
        if (payload.new_status !== undefined) {
          Vue.set(state.profile, 'new_status', payload.new_status);
        }
        if (payload.status !== undefined && payload.status !== null) {
          Vue.set(state.profile, 'status', payload.status);
        }
      }
    },
    setApplicantMemo(state, payload) {
      state.profile.memo = payload;
    },
    setIndividualJd(state, payload) {
      state.individualJD = payload;
    },
    setApplicantJd(state, payload) {
      state.applicantJD = payload;
    },
    setJdForContact(state, payload) {
      state.jdForContact = payload;
    },
    setUserBasedMatching(state, payload) {
      state.userBasedMatching = payload;
    },
    setProfileView(state, payload) {
      const { view, applicantJD, individualJD, userBasedMatching } = payload;
      state.profileView = view;
      if (view === 'jdList') {
        state.applicantJD = applicantJD;
        state.individualJD = null;
        state.userBasedMatching = userBasedMatching;
      } else if (view === 'jdInfo') {
        state.applicantJD = applicantJD;
        state.individualJD = individualJD || applicantJD;
        state.userBasedMatching = userBasedMatching;
      }
    },
    setListAllJds(state, payload) {
      state.listAllJds = payload;
    },
    clearJDDatas(state, payload) {
      state.profileLoaded = false;
      state.applicantJD = null;
      state.profileView = null;
      state.currentJDListPage = 1;
      state.scoutedJD = null;
      if (payload === 'toggle') {
        state.profileView = 'jdInfo';
      } else {
        state.individualJD = null;
      }
    },
    setDefaultLoaded(state, payload) {
      state.defaultLoaded = payload;
    },
    setPreviewListSearchParams(state, payload) {
      state.previewListSearchParams = payload;
    },
    setPreviewApplicants(state, data) {
      state.previewApplicants = data;
      state.isPreview = true;
    },
    setBulkActiveCategory(state, categories) {
      // eslint-disable-next-line
      state.activeCategory = categories;
    },
    clearAll(state) {
      /* eslint-disable */
      state.categories = [];
      state.applicants = [];
      state.activeCategory = [];
      state.favoritesOnly = false;
      state.interviewsOnly = false;
      state.showSearchModal = false;
      state.showFilterModal = false;
      state.showSearchEditModal = false;
      state.searchParams = {};
      state.scoutSearchParams = {};
      state.selectors = {};
      state.sortBy = '';
      state.mainJobModel = [];
      state.childJobModel = [];
      state.englishSkillModel = [];
      state.finalEducationModel = [];
      state.resume_model = null;
      state.jobSummaryModel = null;
      (state.eventModel = []),
        (state.events = []),
        (state.statusModel = []),
        (state.receivedStatusModel = []),
        (state.sentStatusModel = []),
        (state.FirstProfileModalOpen = false);
      state.company_model = [];
      state.scoutHope = null;
      state.applicantsCount = {};
      state.manuallyCheckedJobs = [];
      state.defaultLoaded = false;
      state.applicantJD = null;
      state.profileView = null;
      state.individualJD = null;
      state.profile = null;
      state.listAllJds = false;
      state.userBasedMatching = false;
      state.isCheckAll = false;
      state.jobseekerIds = [];
    },
    setResetCheckAll(state, payload){
      state.isCheckAll = false
    },
    setResetApplicantIds(state, payload) {
      state.jobseekerIds = [];
    },
    resetApplicantListState(state) {
      state.applicants = [];
      state.currentPageApplicants = [];
      state.applicantsCount = {};
      state.pagination = {};
      state.page = 1;
      state.isCheckAll = false;
      state.jobseekerIds = [];
      state.reloadApplicants = false;
      state.loading = false;
      state.sortBy = '';
      state.searchParams = {};
      state.scoutSearchParams = {};
    },
    setApplicantCounts(state, data) {
      state.applicantsCount = data;
    },
    setPreviewApplicantCounts(state, data) {
      state.previewApplicantCounts = data;
    },
    setPage(state, payload) {
      if (typeof payload === 'number') {
        state.page = payload;
        state.FirstProfileModalOpen = false;
        state.LastProfileModalOpen = false;
      } else {
        state.page = payload.page;
        state.FirstProfileModalOpen = payload.FirstProfileModalOpen;
        state.LastProfileModalOpen = payload.LastProfileModalOpen;
      }
    },
    setProfileModalState(state, payload) {
      state.FirstProfileModalOpen = payload;
      state.LastProfileModalOpen = payload;
      state.page = 1;
    },
    setChildJobModel(state, data) {
      state.childJobModel = data;
    },
    setMainJobModel(state, data) {
      state.mainJobModel = data;
    },
    setEnglishSkillModel(state, data) {
      state.englishSkillModel = data;
    },
    setFinalEducationModel(state, data) {
      state.finalEducationModel = data;
    },
    setResumeModel(state, data) {
      state.resume_model = data;
    },
    setJobSummaryModel(state, data) {
      state.jobSummaryModel = data;
    },
    setEventModel(state, data) {
      state.eventModel = data;
    },
    setStatusModel(state, data) {
      state.statusModel = data;
    },
    setScoutTypeModel(state, data) {
      state.scoutTypeModel = data;
    },
    setScoutedBy(state, data) {
      state.scoutedBy = data;
    },
    setScoutHope(state, value) {
      state.scoutHope = value;
    },
    setSentStatusModel(state, data) {
      state.sentStatusModel = data;   
    },
    setReceivedStatusModel(state, data) {
      state.receivedStatusModel = data;
    },
    setReviewListModel(state, data) {
      state.reviewListModel = data;
    },
    setAllReviewListModel(state, data) {
      state.allReviewListModel = data;
    },
    setAllReviewLists(state, data) {
      state.reviewLists = data;
    },
    setAllReviewLists(state, data) {
      state.reviewLists = data;
    },
    setColorModel(state, data) {
      state.colorModel = data;
    },
    setScoutedJd(state, data) {
      state.scoutedJD = data;
    },
    mutateApplicantReadStatus(state, applicant) {
      const index = state.applicants.findIndex((a) => a.id === applicant.id);
      if (index !== -1) {
        Vue.set(state.applicants, index, {
          ...state.applicants[index],
          profile_view_status: applicant.profile_view_status,
        });
      }
    },
    mutateApplicantsAfterFav(state, applicant) {
      const index = state.applicants.findIndex((a) => a.id === applicant.id);
      if (index !== -1) {
        Vue.set(state.applicants, index, {
          ...state.applicants[index],
          isFavorite: applicant.isFavorite,
        });
      }
    },
    mutateApplicantsAfterInterview(state, applicant) {
      const index = state.applicants.findIndex((a) => a.id === applicant.id);
      if (index !== -1) {
        Vue.set(state.applicants, index, {
          ...state.applicants[index],
          isInterview: applicant.isInterview,
        });
      }
    },
    mutateApplicantsAfterMemo(state, applicant) {
      const index = state.applicants.findIndex((a) => a.id === applicant.id);
      if (index !== -1) {
        Vue.set(state.applicants, index, {
          ...state.applicants[index],
          memo: applicant.memo,
        });
      }
    },
    mutateApplicantsAfterJDToggle(state, { applicant: id, jd, unselect }) {
      const index = state.applicants.findIndex((a) => a.id === id);
      if (index !== -1) {
        const updatedApplicant = { ...state.applicants[index] };
        if (unselect) {
          updatedApplicant.markedjobseekers = [];
        } else {
          // Transform the JD data structure from job_title to jobDescriptionTitle format
          const transformedJD = {
            _id: jd._id,
            company: jd.company,
            jd_id: jd.jd_id,
            jd_url: jd.jd_url,
            jobDescription: jd.job_description,
            jobDescriptionTitle: jd.job_title,
            location: jd.location,
            qualification: jd.qualification
          };
          updatedApplicant.markedjobseekers = [transformedJD];
        }
        Vue.set(state.applicants, index, updatedApplicant);
      }
    },
    mutateApplicantsAfterContact(state, { applicantId, contact }) {
      const index = state.applicants.findIndex((a) => a.id === applicantId);
      if (index !== -1) {
        const latestContact = normalizeContactForLatestContact(contact);
        Vue.set(state.applicants, index, {
          ...state.applicants[index],
          hasContact: true,
          latestContact,
        });
      }
    },
    mutateApplicantsAfterColorChange(state, applicant) {
      const index = state.applicants.findIndex((a) => a.id === applicant.id);
      if (index !== -1) {
        Vue.set(state.applicants, index, {
          ...state.applicants[index],
          color: applicant.color,
        });
      }
    },
    mutateApplicantsAfterStatus(state, applicant) {
      const index = state.applicants.findIndex((a) => a.id === applicant.id);
      if (index !== -1) {
        Vue.set(state.applicants, index, {
          ...state.applicants[index],
          new_status: applicant.new_status,
          status: applicant.status,
        });
      }
    },
    removeApplicantFromList(state, applicant) {
      const newApplicants = state.applicants.filter(
        (app) => app.id !== applicant.id
      );
      state.applicants = newApplicants;
    },
    removeApplicantFromTempList(state, applicant) {
      const newApplicants = state.currentPageApplicants.filter(
        (app) => app.id !== applicant.id
      );
      state.currentPageApplicants = newApplicants;
    },
    mutateApplicantsAfterMultipleStatus(state, applicants) {
      const newApplicants = state.applicants.map((app) => {
        const foundApplicant = applicants.find((applicant) => {
          return applicant.id === app.id;
        });
        if (foundApplicant) {
          app.status = foundApplicant.status;
        }
        return app;
      });
      state.applicants = [];
      const isReviewer = store.getters.isCreateReviewUser;
      const currentFilteredStatus = store.getters.getStatusModel;
      let filteredApplicants = newApplicants;
      if (!isReviewer) {
        if (
          currentFilteredStatus.length === 1 &&
          currentFilteredStatus[0] == '確認中'
        ) {
          filteredApplicants = newApplicants.filter(
            (app) => app.status === '確認中'
          );
        }
      }
      state.applicants = filteredApplicants;
    },
    mutateApplicantsAfterMultipleColor(state, applicants) {
      const newApplicants = state.applicants.map((app) => {
        const foundApplicant = applicants.find((applicant) => {
          return applicant.id === app.id;
        });
        if (foundApplicant) {
          app.color = foundApplicant.color;
        }
        return app;
      });
      state.applicants = [];
      state.applicants = newApplicants;
    },
    mutateApplicantsAfterMultipleMemo(state, applicants) {
      applicants.forEach((updatedApplicant) => {
        const index = state.applicants.findIndex((app) => app.id === updatedApplicant.id);
        if (index !== -1) {
          Vue.set(state.applicants, index, {
            ...state.applicants[index],
            memo: updatedApplicant.memo,
          });
        }
      });
    },
    mutateApplicantsAfterReviewList(state, { applicant, fromPopup }) {
      const newApplicants = state.applicants.map((app) => {
        if (applicant.id === app.id) {
          app.review_lists = applicant.review_lists;
        }
        return app;
      });
      state.applicants = [];
      if (fromPopup) {
        state.applicants = newApplicants;
      } else {
        const filteredApplicants = newApplicants.filter(
          (app) => app.id !== applicant.id
        );
        state.applicants = filteredApplicants;
      }
    },

    setReloadApplicants(state, payload) {
      state.reloadApplicants = payload;
    },
    mutateApplicantsAfterMultipleReviewList(state, applicants) {
      // const newApplicants = state.applicants.map((app) => {
      //   const foundApplicant = applicants.find(applicant => {
      //     return applicant.id === app.id
      //   })
      //   if (foundApplicant){
      //     app.review_lists = foundApplicant.review_lists;
      //   }
      //   return app;
      // });
      // state.applicants = [];
      const applicantsToKeep = state.applicants.filter(
        (app) =>
          !applicants.some((foundApplicant) => foundApplicant.id === app.id)
      );
      state.applicants = applicantsToKeep;
    },
    setCompanyModel(state, data) {
      state.company_model = data;
    },
    setManuallyCheckedJobs(state, data) {
      state.manuallyCheckedJobs = data;
    },
    updateMainJobModel(state, data) {
      const { mainJobs } = data;
      state.childJobModel = [];
      mainJobs.forEach((job) => {
        const main = state.selectors.occupations.find(
          (occupation) => job === occupation.id
        );
        // eslint-disable-next-line
        main.children.forEach((child) => state.childJobModel.push(child._id));
      });
      let temp = [...state.manuallyCheckedJobs];
      state.manuallyCheckedJobs.forEach((job_id) => {
        if (state.childJobModel.indexOf(job_id) === -1) {
          state.childJobModel.push(job_id);
        } else {
          let index = temp.indexOf(job_id);
          temp.splice(index, 1);
        }
      });
      state.manuallyCheckedJobs = [...temp];
    },
    setCurrentJDListPage(state, page) {
      state.currentJDListPage = page;
    },
    setIsJdSearch(state, value) {
      state.isJdSearch = value;
    },
  },
  getters: {
    getJdSectionState(state) {
      return state.showJdSection;
    },
    getProfile(state) {
      return state.profile;
    },
    getMatchedJd(state) {
      return state.matchedJd;
    },
    getApplicantJd(state) {
      return state.applicantJD;
    },
    getActiveCategory(state) {
      return state.activeCategory;
    },
    getEvents(state) {
      return state.events;
    },
    getAllReviewLists(state) {
      return state.reviewLists;
    },
    getApplicantCounts(state) {
      return state.applicantsCount;
    },
    getDefaultLoaded(state) {
      return state.defaultLoaded;
    },
    getListAllJds(state) {
      return state.listAllJds;
    },
    getUserBasedMatching(state) {
      return state.userBasedMatching;
    },
    getProfileView(state) {
      return state.profileView;
    },
    getPreviewApplicantCounts(state) {
      return state.previewApplicantCounts;
    },
    getPage(state) {
      return state.page;
    },
    getChildJobModel(state) {
      return state.childJobModel;
    },
    getMainJobModel(state) {
      return state.mainJobModel;
    },
    getEnglishSkillModel(state) {
      return state.englishSkillModel;
    },
    getFinalEducationModel(state) {
      return state.finalEducationModel;
    },
    getResumeModel(state) {
      return state.resume_model;
    },
    getJobSummaryModel(state) {
      return state.jobSummaryModel;
    },
    getEventModel(state) {
      return state.eventModel;
    },
    getStatusModel(state) {
      return state.statusModel;
    },
    getScoutTypeModel(state) {
      return state.scoutTypeModel;
    },
    getScoutedBy(state) {
      return state.scoutedBy;
    },
    getScoutHope(state) {
      return state.scoutHope;
    },
    getSentStatusModel(state) {
      return state.sentStatusModel;
    },
    getReceivedStatusModel(state) {
      return state.receivedStatusModel;
    },
    getStatusColorMap(state) {
      return state.statusColorMap;
    },
    getReviewListModel(state) {
      return state.reviewListModel;
    },
    getAllReviewListModel(state) {
      return state.allReviewListModel;
    },
    getClientStatus(state) {
      return state.client_status;
    },
    getScoutType(state) {
      return state.scoutType;
    },
    getColorModel(state) {
      return state.colorModel;
    },
    getClientColor(state) {
      return state.client_color;
    },
    getFirstProfileModalOpen(state) {
      return state.FirstProfileModalOpen;
    },
    getLastProfileModalOpen(state) {
      return state.LastProfileModalOpen;
    },
    getCompanyModel(state) {
      return state.company_model;
    },
    getHasAssignedApplicants(state) {
      return state.hasAssignedApplicants;
    },
    getApplicantReadStatus: (state) => (id) => {
      const applicant = state.applicants.find((app) => app.id === id);
      if (applicant) {
        return applicant.profile_view_status;
      }
      return null;
    },
    getIsJdSearch: (state) => state.isJdSearch,
  },
  actions: {
    [APPLICANT_ACTIONS.LOAD_CATEGORIES](context, params = {}) {
      return ApiService.get(Api.endpoints.CATEGORIES, {}, params);
    },
    [APPLICANT_ACTIONS.LOAD_APPLICANTS](context, params = {}) {
      return ApiService.get(Api.endpoints.APPLICANTS, {}, params);
    },
    [APPLICANT_ACTIONS.LOAD_SCOUT_APPLICANTS](context, params = {}) {
      return ApiService.get(Api.endpoints.SCOUT_APPLICANTS, {}, params);
    },
    [APPLICANT_ACTIONS.LOAD_SELECTORS]() {
      return ApiService.get(Api.endpoints.SELECTORS);
    },
    [APPLICANT_ACTIONS.LOAD_EVENTS]() {
      return ApiService.get(Api.endpoints.EVENTS);
    },
    [APPLICANT_ACTIONS.LOAD_ALL_REVIEWLIST]() {
      return ApiService.get(Api.endpoints.REVIEW_LISTS);
    },
    loadJdSectionState({ commit }) {
      const showJdSection = sessionStorage.getItem('showJdSection');
      if (showJdSection !== null) {
        commit('setJdSectionState', showJdSection === 'true');
      }
    },
    toggleJdSection({ commit }) {
      commit('toggleJdSection');
    },
    async checkAssignedReviewList({ commit, state }, reviewListId) {
      // console.log('checkAssignedReviewList', reviewListId);
      const { data } = await ApiService.get(Api.endpoints.CHECK_ASSIGNED_REVIEW_LIST, {}, { review_list_id: reviewListId });
      commit('setHasAssignedApplicants', data.data.count > 0);
    },
    async setReadStatus({ commit, state }, id) {
      try {
        const statusToUpdate = 'read';

        const { data } = await ApiService.put(
          Api.endpoints.MARK_APPLICANT_READ(id),
          {
            status: statusToUpdate,
          }
        );
        const response = data.data;
        if (response) {
          commit('mutateApplicantReadStatus', {
            id,
            profile_view_status: statusToUpdate,
          });
        }
        // this.mutateApplicantReadStatus({
        //   id: this.applicantData.id,
        //   profile_view_status: statusToUpdate
        // });
      } catch (error) {
        console.error('Error marking applicant as read:', error);
        // Failed to mark as read, but user can still view profile
      }
    },
    async toggleJobseekerSelection(
      { commit, state },
      { jd, unselect, id, data }
    ) {
      try {
        if (unselect) {
          await ApiService.put(Api.endpoints.UNSELECT_JOBSEEKER(jd._id, id));
          commit('setApplicantJd', null);
          commit('mutateApplicantsAfterJDToggle', {
            applicant: id,
            jd,
            unselect
          });
        } else {
          const response = await ApiService.put(
            `${Api.endpoints.MARK_JOBSEEKERS_MANUALLY(jd._id)}`,
            data
          );
          const jobseeker = response.data.data;
          commit('mutateApplicantsAfterMemo', jobseeker);
          commit('mutateApplicantsAfterJDToggle', { 
            applicant: id,
            jd, 
            unselect 
          });
          commit('setProfile', {
            ...state.profile,
            memo: jobseeker.memo,
            scout_jobs: state.profile.scout_jobs,
          });
          commit('setApplicantJd', jd);
        }
      } catch (error) {
        throw error;
      }
    },
    async multipleJobseekerSelection({ commit }, { jd, jobseekers, data }) {
      try {
        const requestBody = {
          data,
          jobseekers,
        };
        const response = await ApiService.put(
          Api.endpoints.MARK_MULTIPLE_JOBSEEKERS(jd._id),
          requestBody
        );
        const jobseekers = response.data.data;

        for (let user of jobseekers) {
          commit('mutateApplicantsAfterMemo', user);
          commit('mutateApplicantsAfterStatus', user);
          commit('setProfile', user);
          commit('setApplicantJd', jd);
        }
      } catch (err) {
        throw err;
      }
    },
    async matchApplicantJd(context, payload, params = {}) {
      return ApiService.get(Api.endpoints.MARK_JOBSEEKERS());
    },
    async loadPreviewApplicants(context, params = {}) {
      return ApiService.get(Api.endpoints.PREVIEW_APPLICANT, {}, params);
    },
    async loadCurrentUserDefaultSearch({ commit }) {
      try {
        const search = await ApiService.get(
          Api.endpoints.DEFAULT_SEARCH_TEMPLATE
        );
        commit(
          APPLICANT_MUTATIONS.CHANGE_SEARCH_PARAMS,
          search.data.data.search ? search.data.data.search : search.data.data
        );
        commit('setDefaultLoaded', true);
      } catch (error) {
        console.log(error);
      }
    },
    highlightProfileInfo({ state }, applicantId) {
      if (!applicantId) return null;

      // Find the matching applicant from the list
      const matchingApplicant = state.applicants.find(
        (app) => app.id === applicantId
      );
      if (!matchingApplicant || !matchingApplicant.highlights) return null;

      const highlights = matchingApplicant.highlights;
      return highlights;
    },
  },
};
